import React from "react"
import { isEqual } from "lodash"

const withLocalStorage = defaultPath => Component => {
  class WithLocalStorage extends React.Component {
    state = { value: {} }
    UNSAFE_componentWillMount() {
      if (typeof window !== "undefined") {
        this.getLocalStorage(defaultPath)
      }
    }

    componentDidUpdate() {
      this.getLocalStorage(defaultPath)
    }

    getLocalStorage = localStoragePath => {
      if (typeof window !== "undefined" && localStorage) {
        let value = localStorage.getItem(
          localStoragePath || this.props.localStoragePath || defaultPath
        )
        try {
          value = JSON.parse(value)
        } catch (err) {
          console.warn(
            "Localstorage for path",
            this.props.localStoragePath,
            "not parsable"
          )
        }
        if (!isEqual(value, this.state.value)) {
          this.setState({ value })
        }
        return value
      }
      return null
    }

    setLocalStorage = (value, localStoragePath = defaultPath) => {
      let parsedValue = value
      try {
        parsedValue = JSON.stringify(value)
      } catch (err) {}
      if (typeof window !== "undefined" && localStorage) {
        localStorage.setItem(
          localStoragePath || this.props.localStoragePath,
          parsedValue
        )
      }
      // this.setState({ value: value })
    }

    render() {
      return (
        <Component
          {...this.props}
          localStorage={this.state.value}
          setLocalStorage={this.setLocalStorage}
          getLocalStorage={this.getLocalStorage}
        />
      )
    }
  }
  return WithLocalStorage
}

export default withLocalStorage
